<evc-frame>
  <div frame-title>
    <h3>Welcome to the Demo App!</h3>
  </div>
  <div frame-content>
    <p>This is a page to showcase a public page integrated to the Platform.</p>
    <p>You can use this space to display any content you like.</p>
  </div>
</evc-frame>
